// extracted by mini-css-extract-plugin
export default {"errorContainer":"noMatch_errorContainer__3A-sd","homePageLink":"noMatch_homePageLink__txQX4"};